import { applyPlayerQueries, QueryBuilder } from "./Helpers";
export const PlayerDataConnection = {
    getLimitsHistory(params) {
        return applyPlayerQueries(QueryBuilder.getLimitsHistory(params));
    },
    getPlayer() {
        return applyPlayerQueries(QueryBuilder.getPlayer());
    }
};
//# sourceMappingURL=PlayerDataConnection.js.map